import { TrackingActions } from './../../state-management/tracking/tracking.action';
import { Component, ViewEncapsulation, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { UsersAction } from '../../state-management/users/users.actions';
import { UsersEffects } from '../../state-management/users/users.effects';
import { DialogsService } from '../../services/dialogs.service';
import { FormsUtils } from '../../resources/forms.utils';
import { Location } from '@angular/common';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { LoginEvents, LoginEventType } from '../../enum/tracking/login-events.enum';
import { AppState } from '../../interfaces/app-state.interface';
import { PiNewPasswordEmailSuccessfullySent } from '../../components/dialogs/pi-new-password-email-successfully-sent/pi-new-password-email-successfully-sent.component';

@AutoUnsubscribe()
@Component({
  selector: `pi-new-password-form`,
  encapsulation: ViewEncapsulation.Emulated,
  templateUrl: './pi-new-password-form.component.html',
  styleUrls: ['./pi-new-password-form.component.scss'],
})
export class PiNewPasswordFormComponent implements OnDestroy {

  @Output() public onSendRequest: EventEmitter<string> = new EventEmitter();
  public form: FormGroup;
  public fbGroup = {
    email: ['', Validators.compose([Validators.required, Validators.email])],
  };
  public pendingRequest: boolean;

  private recoverPasswordFlowSubscription: Subscription;
  private modalSubscription: Subscription;
  private authenticationSubscription: Subscription;
  private configModal = {
    icon: 'icon_color_highlight_off',
    failSolicit: 'A solicitação falhou',
    failEmail: 'O e-mail não foi enviado, verifique se você digitou o e-mail corretamente e tente novamente.',
    again: 'Tentar novamente',
  };

  constructor(
    private formBuilder: FormBuilder,
    private store: Store<AppState>,
    private usersEffects: UsersEffects,
    private dialogsService: DialogsService,
    private formUtils: FormsUtils,
    private location: Location,
  ) {
    this.form = formBuilder.group(this.fbGroup);
    this._authenticationObserver();
    this._recoverPasswordObserver();
  }

  // não remover, necessário para o funcionamento correto do @AutoUnsubscribe
  // tslint:disable-next-line:no-empty
  public ngOnDestroy() { }

  /** Encaminha o e-mail para recuperar a senha */
  public sendEmail() {
      this.formUtils.ValidFormBase(this.form)
      .then(() => {
        this.store.dispatch({ type: UsersAction.sendForgotPasswordEmail, payload: this.form.controls.email.value });
      });
  }

  public cancel() {
    this.location.back();
  }

  private _authenticationObserver() {
    this.authenticationSubscription = this.store.select((s) => s.authentication)
      .subscribe((result) => {
        this.pendingRequest = result.sendingEmail;
      });
    return this;
  }

  private _recoverPasswordObserver() {
    this.recoverPasswordFlowSubscription = this.usersEffects.sendForgotPasswordEmail$
      .subscribe((action) => {
        if (action.type.equals(UsersAction.forgotPasswordEmailSuccefulySent)) {
          this._successNewPassWord();
        } else {
          this._failNewPassWord();
        }
      });
  }

  private _successNewPassWord() {
    this.dialogsService.showComponnent(PiNewPasswordEmailSuccessfullySent);
    this.store.dispatch({
      type: TrackingActions.trackLoginEvent,
      payload: {
        type: LoginEventType.Success,
        event: LoginEvents.novaSenhaEnviada,
      },
    });
  }

  private _failNewPassWord() {
    this.store.dispatch({
      type: TrackingActions.trackLoginEvent,
      payload: {
        type: LoginEventType.Error,
        event: LoginEvents.esqueciSenha,
      },
    });

    this.modalSubscription = this.dialogsService
      .showSimpleModal(
        this.configModal.icon,
        this.configModal.failSolicit,
        this.configModal.failEmail,
        this.configModal.again,
      ).subscribe(() => {
        //
      });
  }
}
